import { IIrpAddEditRequest } from '../../../../model/scp/irp/request/irp-add-edit-request';
import { ITableResponse } from '../../../../model/scp/purchase/response/tables-response';
import { IUnidEntityResponse } from '../../../../model/scp/entity/response/unid-entity-response';

export type IrpCreateEditState = {
  file?: File;
  tabIndex1: number;
  irpRequest: IIrpAddEditRequest;
  modality: ITableResponse[];
  disputeMode: ITableResponse[];
  instrumentSummons: ITableResponse[];
  legalSupport: ITableResponse[];
  typeDocument: ITableResponse[];
  unidEntity: IUnidEntityResponse[];
  itemsIrpJson: string;
  irpId?: number;
  showValidationErrors: boolean;
};

export enum ACTION_TYPES {
  setFile = 'setFile',
  setTabIndex1 = 'setTabIndex1',
  setIrpRequest = 'setIrpRequest',
  setModality = 'setModality',
  setDisputeMode = 'setDisputeMode',
  setInstrumentSummons = 'setInstrumentSummons',
  setLegalSupport = 'setLegalSupport',
  setTypeDocument = 'setTypeDocument',
  setUnidEntity = 'setUnidEntity',
  setItemsIrpJson = 'setItemsIrpJson',
  setShowValidationErrors = 'setShowValidationErrors',
}

export const IrpCreateEditReducer = (state: IrpCreateEditState, action: any): IrpCreateEditState => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.setFile:
      return { ...state, file: payload };
    case ACTION_TYPES.setTabIndex1:
      return { ...state, tabIndex1: payload };
    case ACTION_TYPES.setIrpRequest:
      return { ...state, irpRequest: { ...state.irpRequest, ...payload } };
    case ACTION_TYPES.setModality:
      return { ...state, modality: payload };
    case ACTION_TYPES.setDisputeMode:
      return { ...state, disputeMode: payload };
    case ACTION_TYPES.setInstrumentSummons:
      return { ...state, instrumentSummons: payload };
    case ACTION_TYPES.setLegalSupport:
      return { ...state, legalSupport: payload };
    case ACTION_TYPES.setTypeDocument:
      return { ...state, typeDocument: payload };
    case ACTION_TYPES.setUnidEntity:
      return { ...state, unidEntity: payload };
    case ACTION_TYPES.setItemsIrpJson:
      return { ...state, itemsIrpJson: payload };
    case ACTION_TYPES.setShowValidationErrors:
      return { ...state, showValidationErrors: payload };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}
